(() => {
  const addComparisonHeaders = (table) => {
    if (table.querySelector('th, table')) return;

    const rows = [...table.rows];
    const firstRow = rows[0];
    if (rows.length < 2 || firstRow.cells.length < 2) return;

    const columnCount = firstRow.cells.length;
    const corner = firstRow.cells[0];
    if (corner.textContent.trim() || corner.querySelector('img, svg, video, iframe, input, button, a')) return;
    if (![...firstRow.cells].slice(1).every((cell) => cell.textContent.trim())) return;
    if (!rows.every((row) => row.cells.length === columnCount && [...row.cells].every((cell) => cell.colSpan === 1 && cell.rowSpan === 1))) return;
    if (!rows.slice(1).every((row) => row.cells[0].textContent.trim())) return;

    const replaceHeader = (cell, scope) => {
      const header = document.createElement('th');
      [...cell.attributes].forEach((attribute) => header.setAttribute(attribute.name, attribute.value));
      header.setAttribute('scope', scope);
      while (cell.firstChild) header.appendChild(cell.firstChild);
      cell.replaceWith(header);
    };

    [...firstRow.cells].slice(1).forEach((cell) => replaceHeader(cell, 'col'));
    rows.slice(1).forEach((row) => replaceHeader(row.cells[0], 'row'));
  };

  const enhanceTables = (root) => {
    root.querySelectorAll('.blog-article__content').forEach((content) => {
      content.querySelectorAll('table').forEach((table) => {
        addComparisonHeaders(table);
        if (table.parentElement.classList.contains('blog-article__table-wrap')) return;

        const wrapper = document.createElement('div');
        wrapper.className = 'blog-article__table-wrap';
        wrapper.setAttribute('role', 'region');
        wrapper.setAttribute('tabindex', '0');
        if (content.dataset.tableLabel) wrapper.setAttribute('aria-label', content.dataset.tableLabel);
        table.before(wrapper);
        wrapper.appendChild(table);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => enhanceTables(document), { once: true });
  } else {
    enhanceTables(document);
  }
  document.addEventListener('shopify:section:load', (event) => enhanceTables(event.target));
})();
